// viewBox trimmed to the drawing's painted bounds, so it fills the box it is given. The
// export padded it, and padding differed per icon — which is what made a row of them read as
// a row of different sizes.
export default function IconCopy({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.14 0.14 17.73 17.73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0.745117 2.73443V1.44824C0.745117 1.03403 1.0809 0.698242 1.49512 0.698242H2.7813M0.745117 6.16042V8.66511M6.20729 0.698242H8.71197M12.098 0.698242H13.2953C13.7094 0.698242 14.0453 1.03403 14.0453 1.44824V2.73443M0.745117 12.0511V13.2484C0.745117 13.6626 1.0809 13.9984 1.49512 13.9984H2.7813"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2559 16.5508C17.2559 16.965 16.9201 17.3008 16.5059 17.3008H5.45801C5.0438 17.3008 4.70801 16.965 4.70801 16.5508V5.50293C4.70801 5.08872 5.0438 4.75293 5.45801 4.75293H16.5059C16.9201 4.75293 17.2559 5.08872 17.2559 5.50293V16.5508Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
